/**
 * Journal days with content, kept up to date incrementally from graph change sets (a structural
 * edit never rescans 200k nodes). A day counts while it is live and has at least one live child.
 */
import { hasLiveChildren, type Graph, type NodeId } from '@solar/core'

export class JournalIndex {
  private readonly g: Graph
  private readonly ids = new Map<NodeId, string>() // journal id → date
  constructor(g: Graph) {
    this.g = g
    for (const n of g.nodes()) if (n.kind === 'journal' && n.date) this.ids.set(n.id, n.date)
    g.subscribe((cs) => {
      for (const id of cs.nodes) {
        const n = g.get(id)
        if (n?.kind === 'journal' && n.date) this.ids.set(id, n.date)
        else if (!n) this.ids.delete(id)
      }
    })
  }

  /** Days with live content, newest first. */
  days(): { date: string; id: NodeId }[] {
    const out: { date: string; id: NodeId }[] = []
    for (const [id, date] of this.ids) if (this.g.isLive(id) && hasLiveChildren(this.g, id)) out.push({ id, date })
    return out.sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0))
  }
}
